export default __webpack_public_path__ + "banner-bg494830.png";